var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-tutor-board-editor",class:{
    'ai-tutor-board-editor--ready': _vm.ready,
    'ai-tutor-board-editor--read-only': _vm.readOnly,
  },attrs:{"data-testid":"ai-tutor-board-editor"}},[_c('div',{ref:"mount",staticClass:"ai-tutor-board-editor__mount"})])}
var staticRenderFns = []

export { render, staticRenderFns }